export const PossibleTimePeriods = Object.freeze({
    Days: "DAYS",
    Weeks: "WEEKS",
    Months: "MONTHS",
});
